module.exports = __webpack_public_path__ + "img/beauty.9a24a1d6.svg";